"use client"

import React, { memo, useEffect } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Content500 } from '../500';
import { Logger } from 'src/utils';

export function ErrorFallback({ error }: FallbackProps) {
    useEffect(() => {
        Logger.error(
            500,
            '|ErrorFallback | ',
            error?.message,
            error?.stack,
            error?.name
        );
        console.error(
            500,
            '|ErrorFallback | ',
            error?.message,
            error?.stack,
            error?.name
        );
    }, []);

    return <Content500 />;
}

export default memo(ErrorBoundary) as any;
